'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/react/react.js
// module id = 0
// module chunks = 0 1 2